import { GroupType } from '@hrms/shared/types';

/* ── Group Management ── */

/* ── Toast & Delay ── */
export const TOAST_DURATION = 3000;
export const REDIRECT_DELAY = 1500;
export const AUTO_GENERATE_DELAY = 300;

/* ── Pagination ── */

export const GROUP_PAGE_SIZE_OPTIONS = [5, 10, 25, 50];
export const DEFAULT_PAGE_SIZE = 10;
export const USERS_FETCH_LIMIT = 100;
export const GROUPS_FETCH_LIMIT = 100;
export const GROUP_MEMBERS_FETCH_LIMIT = 1000;
export const DEFAULT_ROWS_PER_PAGE = 10;

/* ── Group Type ── */

export const GROUP_TYPE_OPTIONS = [
  {
    value: GroupType.MANUAL,
    label: 'Manual',
  },
];
export const TYPE_OPTIONS = GROUP_TYPE_OPTIONS;

// Display badges for every GroupType. Note GROUP_TYPE_OPTIONS above
// deliberately omits ROLE_BASED: those groups are created and maintained
// automatically by Group.syncByRole(), not chosen by a user.
export const GROUP_TYPE_BADGES = {
  [GroupType.MANUAL]: {
    cls: 'gm-badge-manual',
    label: 'Manual',
  },
  [GroupType.ROLE_BASED]: {
    cls: 'gm-badge-role-based',
    label: 'Role-based',
  },
} as const;

/* ── Status ── */

export const STATUS_OPTIONS = [
  {
    value: 'active',
    label: 'Active',
  },
  {
    value: 'inactive',
    label: 'Inactive',
  },
];

/* ── Table ── */

export const TABLE_COLUMNS = [
  { header: 'Group', skeletonWidth: 160 },
  { header: 'Type', skeletonWidth: 90 },
  { header: 'Members', skeletonWidth: 60 },
  { header: 'Owner', skeletonWidth: 120 },
  { header: 'Status', skeletonWidth: 70 },
  { header: 'Created', skeletonWidth: 90 },
];

/* ── Messages ── */
export const DELETE_GROUP_TITLE = 'Delete Group';
export const DELETE_GROUP_CONFIRM = 'Are you sure you want to delete this group? This action cannot be undone.';
